import type { RouteRecordRaw } from 'vue-router';

export const infoSurveyRoutes: Array<RouteRecordRaw> = [
  {
    path: '/info/survey',
    name: 'infoSurvey',
    redirect: '/info/survey/project/list',
    component: () => import('pages/micros/survey/project/SurveyProject.vue'),
    meta: {
      title: 'Surveys Service - for private & public surveys',
      requiresAuth: true,
    },
    children: [],
  },
  {
    path: '/info/survey/project',
    name: 'infoSurveyProject',
    redirect: '/info/survey/project/list',
    component: () => import('pages/micros/survey/project/SurveyProject.vue'),
    meta: {
      title: 'Survey Projects - for private & public surveys',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'infoSurveyProjectList',
        component: () => import('pages/micros/survey/project/SurveyList.vue'),
        meta: {
          title: 'Survey Projects List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'infoSurveyProjectDetail',
        component: () => import('pages/micros/survey/project/SurveyDetail.vue'),
        meta: {
          title: 'Support Project Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'infoSurveyProjectNew',
        component: () => import('pages/micros/survey/project/SurveyNew.vue'),
        meta: {
          title: 'New Survey Project',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/info/survey/access',
    name: 'infoSurveyAccess',
    redirect: '/info/survey/access/list',
    component: () => import('pages/micros/survey/access/SurveyAccess.vue'),
    meta: {
      title: 'Survey access assignment for private surveys',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'infoSurveyAccessList',
        component: () => import('pages/micros/survey/access/SurveyAccessList.vue'),
        meta: {
          title: 'Survey Accesses List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'infoSurveyAccessDetail',
        component: () => import('pages/micros/survey/access/SurveyAccessDetail.vue'),
        meta: {
          title: 'Survey Access Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'infoSurveyAccessNew',
        component: () => import('pages/micros/survey/access/SurveyAccessNew.vue'),
        meta: {
          title: 'New Survey Access',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/info/survey/category',
    name: 'infoSurveyCategory',
    redirect: '/info/survey/category/list',
    component: () => import('pages/micros/survey/category/SurveyCategory.vue'),
    meta: {
      title: 'Survey Categories',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'infoSurveyCategoryList',
        component: () => import('pages/micros/survey/category/SurveyCategoryList.vue'),
        meta: {
          title: 'Survey Categories List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'infoSurveyCategoryDetail',
        component: () => import('pages/micros/survey/category/SurveyCategoryDetail.vue'),
        meta: {
          title: 'Survey Category Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'infoSurveyCategoryNew',
        component: () => import('pages/micros/survey/category/SurveyCategoryNew.vue'),
        meta: {
          title: 'New Survey Category',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/info/survey/question',
    name: 'infoSurveyQuestion',
    redirect: '/info/survey/question/list',
    component: () => import('pages/micros/survey/question/SurveyQuestion.vue'),
    meta: {
      title: 'Survey Questions',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'infoSurveyQuestionList',
        component: () => import('pages/micros/survey/question/SurveyQuestionList.vue'),
        meta: {
          title: 'Comments List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'infoSurveyQuestionDetail',
        component: () => import('pages/micros/survey/question/SurveyQuestionDetail.vue'),
        meta: {
          title: 'Survey Question Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'infoSurveyQuestionNew',
        component: () => import('pages/micros/survey/question/SurveyQuestionNew.vue'),
        meta: {
          title: 'New Survey Question',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/info/survey/answer',
    name: 'infoSurveyAnswer',
    redirect: '/info/survey/answer/list',
    component: () => import('pages/micros/survey/answer/SurveyAnswer.vue'),
    meta: {
      title: 'Survey Answers / Expectations',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'infoSurveyAnswerList',
        component: () => import('pages/micros/survey/answer/SurveyAnswerList.vue'),
        meta: {
          title: 'Survey Answers / Expectations List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'infoSurveyAnswerDetail',
        component: () => import('pages/micros/survey/answer/SurveyAnswerDetail.vue'),
        meta: {
          title: 'Survey Answer / Expectation Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'infoSurveyAnswerNew',
        component: () => import('pages/micros/survey/answer/SurveyAnswerNew.vue'),
        meta: {
          title: 'New Survey Answer / Expectation',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/info/survey/responder',
    name: 'infoSurveyResponder',
    redirect: '/info/survey/responder/list',
    component: () => import('pages/micros/survey/responder/SurveyResponder.vue'),
    meta: {
      title: 'Survey Responders to the survey questions',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'infoSurveyResponderList',
        component: () => import('pages/micros/survey/responder/SurveyResponderList.vue'),
        meta: {
          title: 'Survey Responders List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'infoSurveyResponderDetail',
        component: () => import('pages/micros/survey/responder/SurveyResponderDetail.vue'),
        meta: {
          title: 'Survey Responder Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'infoSurveyResponderNew',
        component: () => import('pages/micros/survey/responder/SurveyResponderNew.vue'),
        meta: {
          title: 'New Survey Responder',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/info/survey/response',
    name: 'infoSurveyResponse',
    redirect: '/info/survey/response/list',
    component: () => import('pages/micros/survey/response/SurveyResponse.vue'),
    meta: {
      title: 'Survey Responses to the survey questions',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'infoSurveyResponseList',
        component: () => import('pages/micros/survey/response/SurveyResponseList.vue'),
        meta: {
          title: 'Survey Responses List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'infoSurveyResponseDetail',
        component: () => import('pages/micros/survey/response/SurveyResponseDetail.vue'),
        meta: {
          title: 'Survey Response Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'infoSurveyResponseNew',
        component: () => import('pages/micros/survey/response/SurveyResponseNew.vue'),
        meta: {
          title: 'New Survey Response',
          requiresAuth: true,
        },
      },
      {
        path: 'wizard/:itemId?',
        name: 'infoSurveyResponseExplorer',
        component: () => import('pages/micros/survey/response/SurveyResponseExplorer.vue'),
        meta: {
          title: 'Survey Vote Response Explorer',
          requiresAuth: true,
        },
      },
      {
        path: 'result/:itemId?',
        name: 'infoSurveyResponseResult',
        component: () => import('pages/micros/survey/response/SurveyResponseResult.vue'),
        meta: {
          title: 'Survey Vote Response Result',
          requiresAuth: true,
        },
      },
    ],
  },

  {
    path: '/info/survey/vote',
    name: 'infoSurveyVote',
    redirect: '/info/survey/vote/list',
    component: () => import('pages/micros/survey/vote/SurveyVote.vue'),
    meta: {
      title: 'Survey voting',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'infoSurveyVoteList',
        component: () => import('pages/micros/survey/vote/VoteList.vue'),
        meta: {
          title: 'Survey Votes List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'infoSurveyVoteDetail',
        component: () => import('pages/micros/survey/vote/VoteDetail.vue'),
        meta: {
          title: 'Survey Vote Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'infoSurveyVoteNew',
        component: () => import('pages/micros/survey/vote/VoteNew.vue'),
        meta: {
          title: 'New Survey Vote',
          requiresAuth: true,
        },
      },
      {
        path: 'explorer',
        name: 'infoSurveyVoteExplorer',
        component: () => import('pages/micros/survey/vote/VoteExplorer.vue'),
        meta: {
          title: 'Survey Votes Explorer',
          requiresAuth: true,
        },
      },
      {
        path: 'view/:itemId?',
        name: 'infoSurveyVoteView',
        component: () => import('pages/micros/survey/vote/VoteView.vue'),
        meta: {
          title: 'Survey Vote View',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/info/survey/stat',
    name: 'infoSurveyStat',
    redirect: '/info/survey/stat/list',
    component: () => import('pages/micros/survey/stat/VoteStat.vue'),
    meta: {
      title: 'Survey voting stats',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'infoSurveyStatList',
        component: () => import('pages/micros/survey/stat/StatList.vue'),
        meta: {
          title: 'Survey Voting Stats List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'infoSurveyStatDetail',
        component: () => import('pages/micros/survey/stat/StatDetail.vue'),
        meta: {
          title: 'Survey Voting Stat Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'infoSurveyStatNew',
        component: () => import('pages/micros/survey/stat/StatNew.vue'),
        meta: {
          title: 'New Survey Stat',
          requiresAuth: true,
        },
      },
    ],
  },

  {
    path: '/info/survey/comment',
    name: 'infoSurveyComment',
    redirect: '/info/survey/comment/list',
    component: () => import('pages/micros/survey/comment/SurveyComment.vue'),
    meta: {
      title: 'Information Comments - for product items...',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'infoSurveyCommentList',
        component: () => import('pages/micros/survey/comment/CommentList.vue'),
        meta: {
          title: 'Comments List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'infoSurveyCommentDetail',
        component: () => import('pages/micros/survey/comment/CommentDetail.vue'),
        meta: {
          title: 'Comment Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'infoSurveyCommentNew',
        component: () => import('pages/micros/survey/comment/CommentNew.vue'),
        meta: {
          title: 'New Comment',
          requiresAuth: true,
        },
      },
      {
        path: 'stat/list',
        name: 'infoSurveyCommentStatList',
        component: () => import('pages/micros/survey/commentStat/CommentStatList.vue'),
        meta: {
          title: 'Comment Stats List',
          requiresAuth: true,
        },
      },
      {
        path: 'stat/detail/:itemId?',
        name: 'infoSurveyCommentStatDetail',
        component: () => import('pages/micros/survey/commentStat/CommentStatDetail.vue'),
        meta: {
          title: 'Comment Stat Details',
          requiresAuth: true,
        },
      },
      {
        path: 'stat/new',
        name: 'infoSurveyCommentStatNew',
        component: () => import('pages/micros/survey/commentStat/CommentStatNew.vue'),
        meta: {
          title: 'New Comment Stat',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/info/survey/rate',
    name: 'infoSurveyRate',
    redirect: '/info/survey/rate/list',
    component: () => import('pages/micros/survey/rate/SurveyRate.vue'),
    meta: {
      title: 'Rates - internal P2P, P2/Group | internet - P2P',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'infoSurveyRateList',
        component: () => import('pages/micros/survey/rate/RateList.vue'),
        meta: {
          title: 'Rates List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'infoSurveyRateDetail',
        component: () => import('pages/micros/survey/rate/RateDetail.vue'),
        meta: {
          title: 'Rate Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'infoSurveyRateNew',
        component: () => import('pages/micros/survey/rate/RateNew.vue'),
        meta: {
          title: 'New Rate',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/info/survey/rating',
    name: 'infoSurveyRating',
    redirect: '/info/survey/rating/list',
    component: () => import('pages/micros/survey/rating/SurveyRating.vue'),
    meta: {
      title: 'Ratings by Categories',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'infoSurveyRatingList',
        component: () => import('pages/micros/survey/rating/RatingList.vue'),
        meta: {
          title: 'Ratings List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'infoSurveyRatingDetail',
        component: () => import('pages/micros/survey/rating/RatingDetail.vue'),
        meta: {
          title: 'Rating Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'infoSurveyRatingNew',
        component: () => import('pages/micros/survey/rating/RatingNew.vue'),
        meta: {
          title: 'New Rating',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/info/survey/view',
    name: 'infoSurveyView',
    redirect: '/info/survey/view/list',
    component: () => import('pages/micros/survey/view/SurveyView.vue'),
    meta: {
      title: 'Views - page views',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'infoSurveyViewList',
        component: () => import('pages/micros/survey/view/ViewList.vue'),
        meta: {
          title: 'Views List',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/info/survey/share',
    name: 'infoSurveyShare',
    redirect: '/info/survey/share/list',
    component: () => import('pages/micros/survey/view/SurveyView.vue'),
    meta: {
      title: 'Shares - page shared with others',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'infoSurveyShareList',
        component: () => import('pages/micros/survey/view/ShareList.vue'),
        meta: {
          title: 'Shares List',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/info/survey/bookmark',
    name: 'infoSurveyBookmark',
    redirect: '/info/survey/bookmark/list',
    component: () => import('pages/micros/survey/bookmark/SurveyBookmark.vue'),
    meta: {
      title: 'Information Bookmarks - for information products...',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list/:bookCategory?/:bookName?/:bookUrl?/:bookId?/:callingPageName?/:path?',
        name: 'infoSurveyBookmarkList',
        component: () => import('pages/micros/survey/bookmark/BookmarkList.vue'),
        meta: {
          title: 'Bookmarks List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?/:bookCategory?/:bookName?/:bookUrl?/:bookId?/:callingPageName?/:path?',
        name: 'infoSurveyBookmarkDetail',
        component: () => import('pages/micros/survey/bookmark/BookmarkDetail.vue'),
        meta: {
          title: 'Bookmark Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new/:bookCategory?/:bookName?/:bookUrl?/:bookId?/:callingPageName?/:path?',
        name: 'infoSurveyBookmarkNew',
        component: () => import('pages/micros/survey/bookmark/BookmarkNew.vue'),
        meta: {
          title: 'New Bookmark',
          requiresAuth: true,
        },
      },
      {
        path: 'explorer/:bookCategory?/:bookName?/:bookUrl?/:bookId?/:callingPageName?/:path?',
        name: 'infoSurveyBookmarkExplorer',
        component: () => import('pages/micros/survey/bookmark/BookmarkExplorer.vue'),
        meta: {
          title: 'Bookmarks Explorer',
          requiresAuth: true,
        },
      },
    ],
  },
];
